import * as React from "react";
import { Button, Delayed } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { Form } from "@grandvisionhq/forms";
import { Alert } from "@grandvisionhq/iris-ui";
import { useCancelAppointmentContext } from "../../../../../../../context/v3/pages/CancelAppointment/context/context.js";
import { CancelAppointmentReasons } from "./CancelAppointmentReasons.js";
import { CancelAppointmentReasonTextarea } from "./CancelAppointmentReasonTextarea.js";
import { getCancellationReasonValue } from "../../../../../helpers/v3/pages/CancelAppointment/routes/default/helpers/get-cancellation-reason-value.js";
import { useGetCancellationQuestions } from "../../../../../hooks/v3/pages/CancelAppointment/routes/default/hooks/use-get-cancellation-questions.js";
/* empty css                           */
const CancelAppointmentForm = ({
  labels,
  onSubmit,
  hasError,
  isCancellationInProgress,
  disableCancelAppointmentButton,
  returnPath
}) => {
  const {
    config: { cancellationReasons }
  } = useCancelAppointmentContext();
  const reasons = useGetCancellationQuestions({
    configuration: cancellationReasons,
    textareaLabel: labels.textareaLabel,
    errorValidation: labels.errorValidation
  });
  return /* @__PURE__ */ React.createElement(
    Form,
    {
      name: "cancellation-reason",
      onSubmit: (state) => onSubmit(getCancellationReasonValue(state))
    },
    /* @__PURE__ */ React.createElement("div", { className: "cancel-appointment-reason-form" }, reasons && reasons.length > 0 ? /* @__PURE__ */ React.createElement(CancelAppointmentReasons, { reasons }) : /* @__PURE__ */ React.createElement(
      CancelAppointmentReasonTextarea,
      {
        label: labels.textareaLabel,
        errorValidation: labels.errorValidation
      }
    )),
    hasError && /* @__PURE__ */ React.createElement(
      Alert,
      {
        variant: "warning",
        title: labels.errorTitle,
        className: "alert-m-default cancel-appointment__alert"
      },
      labels.errorMessage
    ),
    /* @__PURE__ */ React.createElement(
      Button,
      {
        variant: "solid",
        caption: labels.cancelButton,
        className: "cancel-appointment__button",
        isLoading: isCancellationInProgress,
        disabled: disableCancelAppointmentButton,
        type: "submit"
      }
    ),
    /* @__PURE__ */ React.createElement(
      Button,
      {
        variant: "ghost",
        caption: labels.closeButton,
        className: "cancel-appointment__button",
        href: returnPath
      }
    ),
    isCancellationInProgress && /* @__PURE__ */ React.createElement(Delayed, { delay: 2500, scrollIntoView: true, className: "cancel-appointment__item" }, /* @__PURE__ */ React.createElement(Text, { color: "text-secondary", align: "center" }, labels.slowLoadingIndication))
  );
};
export {
  CancelAppointmentForm
};
//# sourceMappingURL=CancelAppointmentForm.js.map
